define('shared/util/adyen/getEnv',[
    '$',
    'Promise',
    'shared/page/env',
    'shared/lib/URI',
], function (
    $,
    Promise,
    env,
    URI
) {
    var uri = new URI(location.href);
    var searchParameters = uri.query(true);

    return function () {
        return env()
            .then(function (environment) {
                if (
                    environment === 'live' || 
                    (
                        searchParameters.adyen_script && 
                        searchParameters.adyen_script === 'live'
                    ) 
                ) {
                    return 'live';
                } else {
                    return 'test';
                }
            });
    };
});
